export default "__VITE_ASSET__BBIMtD6L__"